import React, { Component } from 'react';
import PropTypes from 'prop-types';
import decl from '../../../helpers/decl';

class DragRange extends Component {
  static propTypes = {
    onChange: PropTypes.func,
    count: PropTypes.number,
    value: PropTypes.number,
    disable: PropTypes.bool,
  };

  constructor(props) {
    super(props);

    this.state = {
      hint:
        props.value == 0 || props.count == 0
          ? 'first'
          : props.count == props.value
          ? 'last'
          : null,
      active: 0,
      currentVal: props.value,
    };
  }

  componentDidMount() {
    const { count, value, onChange, disable } = this.props;

    this.dragSlider = new Dragdealer($(this.drag).attr('id'), {
      steps: count + 1,
      vertical: false,
      speed: 0.5,
      slide: false,
      x: (1 / count) * value,
      handleClass: 'drag-steps__handle',
      animationCallback: x => {
        const { hint } = this.state;

        $(this.drag)
          .find('.drag-steps__progress')
          .css('width', `${(x * 100).toFixed(2)}%`);

        if (count) {
          const k = Math.floor(100 / count) / 100;
          const active = Math.floor(x / k);
          const currentVal = Math.floor(x * count);

          this.setState({ active, currentVal });

          if (x > 0.98) {
            if (hint != 'last') {
              this.setState({
                hint: 'last',
              });
            }
          } else if (x < 0.02) {
            if (hint != 'first') {
              this.setState({
                hint: 'first',
              });
            }
          } else {
            if (hint) {
              this.setState({
                hint: null,
              });
            }
          }
        }
      },
      callback: x => {
        const { value } = this.props;
        const step = Math.round(this.dragSlider.getStep()[0] - 1);

        if (value != step) {
          onChange(step);
        }
      },
    });

    if (disable) {
      this.dragSlider.disable();
    } else {
      this.dragSlider.enable();
      // this.dragSlider.setStep(value);

      if (this.dragSlider && this.props.reflow) {
        this.dragSlider.reflow();
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.disable) {
      this.dragSlider.disable();
    } else {
      this.dragSlider.enable();
    }
  }

  render() {
    const { count, value, price } = this.props;
    const { hint, active, currentVal } = this.state;

    const steps = [];

    for (let i = 0; i < count; i++) {
      steps.push(<span key={i} className={i < active ? 'active' : null} />);
    }

    const popClasses = ['popover'];

    switch (hint) {
      case 'first':
        popClasses.push('popover--first');
        break;

      case 'last':
        popClasses.push('popover--last');
        break;

      default:
        break;
    }

    // old steps
    let stepsRender = null;
    if (false) {
      stepsRender = <div className="drag-steps__steps">{steps}</div>;
    }

    return (
      <div
        className="drag-steps"
        id="bonus_drag"
        ref={node => (this.drag = node)}
      >
        {stepsRender}
        <div className="drag-steps__progress" />
        <div className="drag-steps__handle">
          <div className={popClasses.join(' ')}>
            <span>
              {currentVal * price}{' '}
              {decl(currentVal * price, ['бонус', 'бонуса', 'бонусов'])}
            </span>
          </div>
        </div>
      </div>
    );
  }
}

export default DragRange;
